import { Route, Routes } from "react-router-dom";
import { Home } from "../pages/Home";
import { NavMenu } from "../ui/NavMenu";

export const AppRouter = () => {
  return (
    <>
      <NavMenu />
      <Routes>
        <Route exact path="/catalogo" element={<Home />} />
      </Routes>
    </>
  )
}
